import { render } from "./ShippingModal.vue?vue&type=template&id=9aea923c&scoped=true"
import script from "./ShippingModal.vue?vue&type=script&lang=js"
export * from "./ShippingModal.vue?vue&type=script&lang=js"

import "./ShippingModal.vue?vue&type=style&index=0&id=9aea923c&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/LEADA/mi-stock-leada-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aea923c"]])

export default __exports__